var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-pre-roll-video-ad"},[_c(_setup.PreRollVideoAd,{attrs:{"adUnit":_setup.adUnit,"listSwiper":true},scopedSlots:_vm._u([{key:"fallback",fn:function(){return [_c(_setup.QualityTV,_vm._b({attrs:{"displayPromotedTag":false}},'QualityTV',_setup.props,false))]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }